export default "__VITE_ASSET__DRdgX8cH__"